
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/opt/bookandgolf-front/sentry.client.config.ts")
            }
          });